<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <v-icon size="60" :color="powerColor" @click.stop="click">{{ powerIcon }}</v-icon>
      </template>
      <template #value>{{ powerName }}</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <SwitchHistoryDialog v-if="dialog" v-model="dialog" :device="device" :endpoint="endpointId" @setting="showSettingsDialog"></SwitchHistoryDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import SwitchHistoryDialog from '@/components/history/SwitchHistoryDialog'

export default {
  name: 'SwitchTile',
  mixins: [EndpointTile],
  components: {
    CenterizedTile,
    IconifiedTile,
    SwitchHistoryDialog
  },
  computed: {
    power() {
      return this.report.on;
    },
    powerIcon() {
      return this.power ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline';
    },
    powerColor() {
      return this.power ? 'primary' : 'grey';
    },
    powerName() {
      return this.power != undefined ? this.$t(this.power ? 'switch.ON' : 'switch.OFF') : '---';
    }
  },
  methods: {
    click() {
      let newPower = !this.power;
      this.$set(this.report, 'on', newPower);
      this.$emit('command', {
        [this.endpointId]: {
          on: newPower
        }
      });
    }
  }
}
</script>
